import React from "react";
import PropTypes from "prop-types";

import { Button } from "semantic-ui-react";

import Form from "components/Form";
import Modal from "components/Modal";

import { useGatedCustomersForm } from "./hooks";

export function AddGatedCustomersModal({ onSubmit, onClose }) {
  const { isReady, formProps, submit, isSubmitting } =
    useGatedCustomersForm(onSubmit);

  return (
    <Modal
      style={{ maxWidth: "400px", maxHeight: "80vh" }}
      isModalOpen
      onClose={onClose}
      data-test="add-gated-customers-modal"
    >
      <Modal.Header onClose={onClose}>
        Add Gated Workflow Customers
      </Modal.Header>
      <Modal.Body scrolling style={{ wordBreak: "break-all" }}>
        <div
          style={{ color: "#B8B8B8", fontSize: "10px", marginBottom: "12px" }}
        >
          Once you add this customer, all administrators in their practice will
          have access to your gated workflow templates.
        </div>

        <Form id="gatedCustomers" onSubmit={submit} {...formProps}>
          <Form.CreatableInput
            required
            name="emails"
            placeholder="Enter email address"
            data-test="gated-customers-input"
          />
        </Form>
      </Modal.Body>
      <Modal.Footer>
        <Button basic content="Cancel" onClick={onClose} />
        <Button
          primary
          type="submit"
          content="Add Customers"
          form="gatedCustomers"
          disabled={!isReady || isSubmitting}
          loading={isSubmitting}
        />
      </Modal.Footer>
    </Modal>
  );
}

AddGatedCustomersModal.propTypes = {
  onSubmit: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

export default AddGatedCustomersModal;
